// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ActiveReelBar_wrapper__v3Jnr","bar":"ActiveReelBar_bar__Inf0J","fullScreenBar":"ActiveReelBar_fullScreenBar__vvHMn","barFill":"ActiveReelBar_barFill__7_KoE"};